import React from "react"
import { withRouter } from "react-router-dom"

import IndexNavbar from "components/Navbars/IndexNavbar.js"
import MerchantProfile from "components/User/MerchantProfile.js"
import Footer from "components/Footers/Footer.js"

class SingleMerchant extends React.Component {
  componentDidMount() {
    // console.log(JSON.stringify(this.props, null, 4));
    // console.log(JSON.stringify(this.props.history, null, 4));
    // console.log(this.props.history.location.pathname);
    // this.props.history.push('/');
    // this.props.history.replace('/');
  }
  render() {
    let redirectPath
    if (this.props && this.props.history && this.props.history.location) {
      redirectPath = this.props.history.location.pathname
    }
    return (
      <>
        <div>
          <IndexNavbar redirectPath={redirectPath} />
          <div className="main-content">
            <MerchantProfile />
          </div>
          <Footer />
        </div>
      </>
    )
  }
}

export default withRouter(SingleMerchant)
